var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth__wrapper"},[_c('Login',{attrs:{"display-header":true,"redirect-on-success":true,"invitation":_vm.invitation,"redirect-by-default":_vm.redirectByDefault}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }